import { EtudeType } from "../Store/Elections/Types";
import { IPermission } from "../Store/User/Types";
import { PaletteMode } from "../Themes";

// const deserializeBoolean = (value: string) => value === 'true';
const deserializeString = (value: string) => value;
const deserializeNumber = (value: string) => Number.parseFloat(value);
const deserializePaletteMode = (value: string) => value as PaletteMode;
const deserializeEtudeType = (value: string) => value as EtudeType;
const deserializeObject = (value: string) =>  {
    return JSON.parse(value);
}
// const serializeBoolean = (value: boolean) => value ? 'true' : 'false';
const serializeString = (value: string) => value;
const serializeNumber = (value: number) => value.toString();
const serializePaletteMode = (value: PaletteMode) => value.toString();
const serializeEtudeType = (value: EtudeType) => value.toString();
const serializeObject = (value: object | null) => JSON.stringify(value);

export interface IKeyValueStorage {
    locale: string;
    userDate: number;
    userName: string;
    userToken: string;
    volume: number;
    politicalRegimeId: number;
    politicalRegimeName: string;
    politicalGroupId: number;
    politicalGroupName: string;
    personId: number;
    personName: string;
    mediaId: number;
    mediaName: string;
    politicalRegimeColor: number;
    politicalGroupColor: number;
    personColor: number;
    theme: PaletteMode;
    etude: EtudeType;
    statsPage: string;
    medias: string;
    permissions: IPermission;
}

const keyValueStorageDeserializers:
    { [key in KeyValueStorageKey]: (value: string) => IKeyValueStorage[key] } = {
        locale: deserializeString,
        userDate: deserializeNumber,
        userName: deserializeString,
        userToken: deserializeString,
        volume: deserializeNumber,
        politicalRegimeId: deserializeNumber,
        politicalRegimeName: deserializeString,
        politicalGroupId: deserializeNumber,
        politicalGroupName: deserializeString,
        personId: deserializeNumber,
        personName: deserializeString,
        mediaId: deserializeNumber,
        mediaName: deserializeString,
        politicalRegimeColor: deserializeNumber,
        politicalGroupColor: deserializeNumber,
        personColor: deserializeNumber,
        theme: deserializePaletteMode,
        etude: deserializeEtudeType,
        statsPage: deserializeString,
        medias: deserializeString,
        permissions: deserializeObject,
};

const keyValueStorageSerializers:
    { [key in KeyValueStorageKey]: (value: IKeyValueStorage[key]) => string } = {
        locale: serializeString,
        userDate: serializeNumber,
        userName: serializeString,
        userToken: serializeString,
        volume: serializeNumber,
        politicalRegimeId: serializeNumber,
        politicalRegimeName: serializeString,
        politicalGroupId: serializeNumber,
        politicalGroupName: serializeString,
        personId: serializeNumber,
        personName: serializeString,
        mediaId: serializeNumber,
        mediaName: serializeString,
        politicalRegimeColor: serializeNumber,
        politicalGroupColor: serializeNumber,
        personColor: serializeNumber,
        theme: serializePaletteMode,
        etude: serializeEtudeType,
        statsPage: serializeString,
        medias: serializeString,
        permissions: serializeObject,
};

export type KeyValueStorageKey = keyof IKeyValueStorage;

export interface IUserStorage {
    del<T extends KeyValueStorageKey>(key: T): void;
    get<T extends KeyValueStorageKey>(key: T, defaultValue: IKeyValueStorage[T]):
        IKeyValueStorage[T];
    reset(): void;
    set<T extends KeyValueStorageKey>(key: T, value: IKeyValueStorage[T]): void;
}

export const TypedStorage: IUserStorage = {
    del: (key) => { localStorage.removeItem(key); },
    get: (key, defaultValue) => {
        const serialized = window.localStorage.getItem(key);

        if (serialized !== null) {
            return (keyValueStorageDeserializers[key](serialized) as any);
        }
        return defaultValue;
    },
    reset: () => { localStorage.clear(); },
    set: (key, value) => {
        const serializer = (keyValueStorageSerializers[key] as (t: any) => string);
        localStorage.setItem(key, serializer(value));
    },
};
